import { SamlErrorCode } from '~common/errors/userFacing';

import { ParseResult } from '..';
import { AbstractHandler } from '.';

export default class InvalidThumprintHandler extends AbstractHandler {
  public handle(error: string, errorDescription: string): ParseResult | null {
    const isError = error === 'access_denied' && errorDescription.startsWith('Invalid thumbprint');

    if (isError) {
      return {
        code: SamlErrorCode.X509_MISMATCH,
      };
    }
    return super.handle(error, errorDescription);
  }
}
